
@if(product?.addToCartEnabled?.toLowerCase() == "yes" || PDPProductData?.addToCartEnabled?.toLowerCase() == "yes") {
<form [formGroup]="addToCartForm" (click)="$event.stopPropagation()" (submit)="$event.preventDefault(); $event.stopPropagation(); addToCart()">
  @if (type === 'PDP') {
    <div class="product-actions">
      <div class="quantity-section">
        <span class="quantity-label">Qty:</span>
        <div class="quantity-controls">
          <button type="button" class="quantity-btn" aria-label="Decrease quantity"
          (click)="decreaseQuantity()">&minus;</button>
          <input type="number" class="quantity-input" formControlName="quantity" [min]="minQuantity"
            (blur)="onQuantityBlur(); onQuantityChange()"  [min]="1" knBrNumbersOnly>
          <button type="button" class="quantity-btn" aria-label="Increase quantity"
          (click)="increaseQuantity()">+</button>
        </div>
      </div>
      <button type="button" class="btn btn-primary" (click)="addToCart()" >
        ADD TO CART
      </button>
    </div>
    }

    @if (cartContext || !quoteContext) {
      @if (type === 'PGP') {
        <div class="p-0 float-left" [class.w-100]="cartContext && !quoteContext" [class.w-50]="!cartContext && !quoteContext">
          <button type="button" class="btn rounded-0 w-100 btn-primary" [disabled]="isSaveDisabled$ | async" (click)="addToCart()">
            <i class="fas fa-cart-plus color-white font-size-18"></i>
          </button>
        </div>
      }
      @if (type === 'PLP') {
        <button type="button" class="btn btn-primary" [disabled]="isSaveDisabled$ | async" (click)="addToCart()">
          Add to Cart
        </button>
      }
      <!-- @if (type === 'QUICK') {
        <button type="button" (click)="addProductsToCart()" [disabled]="(productList && productList.length < 1) " class="btn btn-primary w-100">
          <i class="fas fa-cart-plus mr-2"></i> {{ 'quickOrder.label.addToCart' | cxTranslate }}
        </button>
      } -->
    }
    <!-- <ng-template #addToCartButtonTip>{{ 'toolTip.addToCart' | cxTranslate }}</ng-template> -->
  </form>
}
